import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/constants";
import { useLanguage } from "@/i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="border-t border-[#4a6cf7]/20 bg-[#081426]">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Ore Source Mining SARLU" className="h-16 w-auto rounded-full bg-white p-1 ring-2 ring-[#4a6cf7]/70 shadow-[0_0_24px_rgba(74,108,247,0.45)]" />
            <div>
              <p className="font-display text-base font-bold text-white">ORE SOURCE MINING SARLU</p>
              <p className="font-mono2 text-[10px] uppercase tracking-[0.35em] text-[#9db4ff]">
                Lubumbashi · DRC
              </p>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">{t("footer.tagline")}</p>
        </div>
        <div>
          <p className="font-display text-xs font-semibold uppercase tracking-[0.3em] text-[#9db4ff]">
            {t("footer.navTitle")}
          </p>
          <div className="mt-5 flex flex-col gap-3 text-sm">
            <Link data-testid="footer-link-home" to="/" className="text-slate-400 transition-colors hover:text-[#9db4ff]">{t("nav.home")}</Link>
            <Link data-testid="footer-link-about" to="/about" className="text-slate-400 transition-colors hover:text-[#9db4ff]">{t("nav.about")}</Link>
            <Link data-testid="footer-link-products" to="/products" className="text-slate-400 transition-colors hover:text-[#9db4ff]">{t("nav.products")}</Link>
            <Link data-testid="footer-link-contact" to="/contact" className="text-slate-400 transition-colors hover:text-[#9db4ff]">{t("nav.contact")}</Link>
            <Link data-testid="footer-link-inquiries" to="/admin/inquiries" className="text-slate-400 transition-colors hover:text-[#9db4ff]">{t("footer.inquiries")}</Link>
          </div>
        </div>
        <div>
          <p className="font-display text-xs font-semibold uppercase tracking-[0.3em] text-[#9db4ff]">
            {t("footer.officeTitle")}
          </p>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            Ore Source Mining Sarlu
            <br />
            5967 AV Kasai, Q/Makutano C/Lubumbashi
            <br />
            Katanga — Lubumbashi, DR Congo
          </p>
          <p className="mt-4 text-sm text-slate-400">
            <span className="text-slate-500">{t("footer.email")}</span> info@oresourcemining.com
            <br />
            <span className="text-slate-500">{t("footer.sales")}</span> sales@oresourcemining.com
            <br />
            <span className="text-slate-500">{t("footer.tel")}</span> +243 999 004 146
          </p>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center">
        <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-slate-500">
          © {new Date().getFullYear()} Ore Source Mining SARLU — {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
